// extracted by mini-css-extract-plugin
export default {"roundImage":"RoundImage_roundImage__Kub48"};